import { render, staticRenderFns } from "./CopyLinkCard.vue?vue&type=template&id=0fa4908a&scoped=true"
import script from "./CopyLinkCard.vue?vue&type=script&lang=js"
export * from "./CopyLinkCard.vue?vue&type=script&lang=js"
import style0 from "./CopyLinkCard.vue?vue&type=style&index=0&id=0fa4908a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa4908a",
  null
  
)

export default component.exports